module.exports = __webpack_public_path__ + "img/20191119163539360截图20191119162705982.24d490ab.jpg";